export default {
  domain: process.env.NEXT_PUBLIC_AUTH0_DOMAIN as string,
  client_id: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID as string,
  audience: process.env.NEXT_PUBLIC_AUTH0_AUDIENCE as string,
  realm: "Username-Password-Authentication",
  scope:
    "openid profile email read:current_user update:current_user_metadata offline_access",
  response_type: "token id_token",
};
